<div
  [matTooltip]="tooltipText"
  matTooltipPosition="above"
  matTooltipClass="multiline-tooltip"
>
  {{ displayText }}
</div>
